import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { getstaffwithid } from "../../../api/FacultyService";
import ProfileTab from "./ProfileTab";
import SaleryInfoTab from "./SaleryInfoTab";
import AttandanceTab from "./AttandanceTab";
import { ToastMain, SweetAlertShow } from "../../master/Master";
import { imgBaseUrl } from "../../../api/api";
import { staffDetails } from "../../../api/Staff";
import SaleryDetails from "./SaleryDetails";
import StaffLayout from "../../staffs/StaffLayout";
import WorkReportTab from "./WorkReportTab";
import usePrivateLink from "../../config/usePrivateLink";

const Teacherview2 = ({ }) => {
  const hasAccess = usePrivateLink();

  const { id } = useParams();
  const navigate = useNavigate();
  const [Teachers, setTeachers] = React.useState([]);
  const [error, setError] = useState("");
  const [Tab, setTab] = useState("Salary_Details");

  const goToEditStaff = () => {
    navigate(`/staff/update?id=${id}`);
  };

  const staffFatch = async () => {
    try {
      const response = await staffDetails(id);
      if (response.status === 200 && response) {
        setTeachers(response.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    }
  };
  useEffect(() => {
    staffFatch();
  }, [id]);
  /* ---------------------------------------------------------------- */
  /*  DERIVED DISPLAY DATA                                             */
  /* ---------------------------------------------------------------- */
  const emp =
    Teachers?.employment_latest || Teachers?.employment_histories?.[0];

  const pendingSalary = (Teachers?.salaries || []).reduce(
    (total, salary) => total + Number(salary.pending_amount || 0),
    0,
  );

  const subjectNames = Teachers?.subjects_text
    ? Teachers.subjects_text.split(",").map((s) => s.trim())
    : [];

  const addressParts = [
    Teachers?.village,
    Teachers?.tehsil,
    Teachers?.district,
    Teachers?.state,
    Teachers?.pincode,
  ].filter(Boolean);

  const hasExperience =
    Teachers?.last_education ||
    Teachers?.last_school ||
    Teachers?.last_designation ||
    Teachers?.last_company ||
    Teachers?.resume;

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Header />
        <div className="layout-page">
          <Nav />
          <div className="content-wrapper">
            <div className="container-fluid py-3">
              <div className="row">
                <StaffLayout />

                {/* ---------------- PAGE HEADER ---------------- */}
                <div className="card border-0 shadow-sm mb-4">
                  <div className="card-body py-3">
                    <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3">
                      <div className="d-flex align-items-center gap-3">
                        <div
                          className="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
                          style={{
                            width: 50,
                            height: 50,
                            background:
                              "linear-gradient(135deg,#696cff,#8b5cf6)",
                            color: "#fff",
                            fontSize: 22,
                          }}
                        >
                          <i className="ri-user-3-line"></i>
                        </div>
                        <div>
                          <h3 className="fw-bold mb-1">
                            {Teachers?.name || "Staff Profile"}
                          </h3>
                          <div className="text-muted small d-flex align-items-center flex-wrap gap-2">
                            <span>
                              Reg No:{" "}
                              <span className="fw-semibold text-body">
                                {Teachers?.registration_no || "-"}
                              </span>
                            </span>
                            {Teachers?.staff_type && (
                              <>
                                <span className="text-body-tertiary">Type:</span>
                                <span className="badge bg-label-primary">
                                  {Teachers.staff_type}
                                </span>
                              </>
                            )}
                            {Teachers?.app_role?.id && (
                              <>
                                <span className="text-body-tertiary">App Role:</span>
                                <span className="badge bg-label-success">
                                  {Teachers.app_role.name}
                                </span>
                              </>
                            )}
                          </div>
                        </div>
                      </div>


                      <div className="d-flex gap-2">
                        {hasAccess("/staff/update") && (
                          <button
                            className="btn btn-primary"
                            onClick={goToEditStaff}
                          >
                            <i className="ri-edit-line me-1"></i>
                            Edit Profile
                          </button>
                        )}
                        {hasAccess("/staff/document/add") && (
                          <Link
                            to={`/student/documents/add?staff_id=${Teachers?.id}`}
                            className="btn btn-outline-primary"
                          >
                            <i className="ri-file-upload-line me-1"></i>
                            Add Document
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="row g-4">
                    {/* ---------------- SIDEBAR ---------------- */}
                    <div className="col-xl-4 col-lg-4">
                      <div className="card border-0 shadow-sm overflow-hidden mb-4">
                        <div
                          className="text-center text-white p-4"
                          style={{
                            background:
                              "linear-gradient(135deg,#696cff,#5f61e6,#8b5cf6)",
                          }}
                        >
                          {Teachers?.img ? (
                            <img
                              src={imgBaseUrl + Teachers?.img}
                              alt=""
                              className="rounded-circle border border-5 border-white shadow"
                              style={{
                                width: 130,
                                height: 130,
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <div
                              className="rounded-circle bg-white text-primary fw-bold d-inline-flex align-items-center justify-content-center border border-5 border-white"
                              style={{
                                width: 130,
                                height: 130,
                                fontSize: 52,
                              }}
                            >
                              {Teachers?.name?.charAt(0) || "S"}
                            </div>
                          )}

                          <h4 className="mt-3 mb-1">{Teachers?.name}</h4>
                          {Teachers?.father_name && (
                            <div className="small opacity-75 mb-2">
                              S/o {Teachers.father_name}
                            </div>
                          )}

                          <div>
                            {Teachers?.staff_type && (
                              <span className="badge bg-light text-dark me-2">
                                {Teachers.staff_type}
                              </span>
                            )}
                            <span
                              className={`badge ${Teachers?.status == 1 ? "bg-success" : "bg-danger"}`}
                            >
                              {Teachers?.status == 1 ? "Active" : "Inactive"}
                            </span>
                          </div>
                        </div>

                        <div className="card-body">
                          <div className="row g-3 mb-4">
                            <div className="col-6">
                              <div className="border rounded text-center p-3">
                                <i className="ri-wallet-3-line text-success fs-2"></i>
                                <h5 className="mt-2 mb-0">
                                  ₹{emp?.current_salary || 0}
                                </h5>
                                <small className="text-muted">
                                  Current Salary
                                </small>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="border rounded text-center p-3">
                                <i className="ri-money-rupee-circle-line text-danger fs-2"></i>
                                <h5 className="mt-2 mb-0">
                                  ₹{pendingSalary.toLocaleString("en-IN")}
                                </h5>
                                <small className="text-muted">
                                  Pending Salary
                                </small>
                              </div>
                            </div>
                          </div>

                          <hr />

                          <div className="row gy-3">
                            <div className="col-12 d-flex align-items-start gap-2">
                              <i className="ri-mail-line text-primary mt-1"></i>
                              <div>
                                <label className="text-muted small d-block">
                                  Email
                                </label>
                                <div className="fw-semibold">
                                  {Teachers?.email || "-"}
                                </div>
                              </div>
                            </div>

                            <div className="col-12 d-flex align-items-start gap-2">
                              <i className="ri-phone-line text-primary mt-1"></i>
                              <div>
                                <label className="text-muted small d-block">
                                  Mobile
                                </label>
                                <div className="fw-semibold">
                                  {Teachers?.mobile || "-"}
                                </div>
                              </div>
                            </div>

                            <div className="col-6 d-flex align-items-start gap-2">
                              <i className="ri-user-line text-primary mt-1"></i>
                              <div>
                                <label className="text-muted small d-block">
                                  Gender
                                </label>
                                <div className="fw-semibold">
                                  {Teachers?.gender || "-"}
                                </div>
                              </div>
                            </div>

                            <div className="col-6 d-flex align-items-start gap-2">
                              <i className="ri-cake-2-line text-primary mt-1"></i>
                              <div>
                                <label className="text-muted small d-block">
                                  Date of Birth
                                </label>
                                <div className="fw-semibold">
                                  {Teachers?.dob || "-"}
                                </div>
                              </div>
                            </div>

                            <div className="col-12 d-flex align-items-start gap-2">
                              <i className="ri-map-pin-line text-primary mt-1"></i>
                              <div>
                                <label className="text-muted small d-block">
                                  Address
                                </label>
                                <div className="fw-semibold">
                                  {addressParts.length
                                    ? addressParts.join(", ")
                                    : "-"}
                                </div>
                              </div>
                            </div>
                          </div>
                          {subjectNames.length > 0 && (
                            <>
                              <hr />
                              <label className="text-muted small d-block mb-2">
                                <i className="ri-book-open-line me-1"></i>
                                Subjects
                              </label>

                              <div className="d-flex flex-wrap gap-2">
                                {subjectNames.map((subject, index) => (
                                  <span
                                    key={index}
                                    className="badge bg-label-primary"
                                  >
                                    {subject}
                                  </span>
                                ))}
                              </div>
                            </>
                          )}

                          <div className="d-grid gap-2 mt-4">
                            {hasAccess("/staff/update") && (
                              <button
                                className="btn btn-primary"
                                onClick={goToEditStaff}
                              >
                                <i className="ri-edit-line me-2" />
                                Edit Profile
                              </button>
                            )}
                            {hasAccess("/staff/document/add") && (
                              <Link
                                to={`/student/documents/add?staff_id=${Teachers?.id}`}
                                className="btn btn-outline-primary"
                              >
                                <i className="ri-file-upload-line me-2" />
                                Add Document
                              </Link>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* ---------------- EXPERIENCE CARD ---------------- */}
                      {hasExperience && (
                        <div className="card border-0 shadow-sm mb-4">
                          <div className="card-header bg-white d-flex align-items-center gap-2">
                            <i className="ri-briefcase-4-line text-primary"></i>
                            <h6 className="mb-0 fw-bold">Experience</h6>
                          </div>
                          <div className="card-body">
                            <div className="row gy-3">
                              {Teachers?.last_designation && (
                                <div className="col-6">
                                  <label className="text-muted small d-block">
                                    Last Designation
                                  </label>
                                  <div className="fw-semibold">
                                    {Teachers.last_designation}
                                  </div>
                                </div>
                              )}
                              {Teachers?.last_company && (
                                <div className="col-6">
                                  <label className="text-muted small d-block">
                                    Last Company
                                  </label>
                                  <div className="fw-semibold">
                                    {Teachers.last_company}
                                  </div>
                                </div>
                              )}
                              {Teachers?.last_school && (
                                <div className="col-6">
                                  <label className="text-muted small d-block">
                                    Last School / Institute
                                  </label>
                                  <div className="fw-semibold">
                                    {Teachers.last_school}
                                  </div>
                                </div>
                              )}
                              {Teachers?.last_education && (
                                <div className="col-12">
                                  <label className="text-muted small d-block">
                                    Education
                                  </label>
                                  <div className="fw-semibold">
                                    {Teachers.last_education}
                                  </div>
                                </div>
                              )}
                              {Teachers?.resume && (
                                <div className="col-12">
                                  <a
                                    href={imgBaseUrl + Teachers.resume}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-outline-primary btn-sm"
                                  >
                                    <i className="ri-file-download-line me-1"></i>
                                    View Resume
                                  </a>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* ---------------- EMPLOYMENT SNAPSHOT ---------------- */}
                      {emp && (
                        <div className="card border-0 shadow-sm">
                          <div className="card-header bg-white d-flex align-items-center gap-2">
                            <i className="ri-building-line text-primary"></i>
                            <h6 className="mb-0 fw-bold">
                              Employment Snapshot
                            </h6>
                          </div>
                          <div className="card-body">
                            <div className="row gy-3">
                              <div className="col-6">
                                <label className="text-muted small d-block">
                                  Joining Date
                                </label>
                                <div className="fw-semibold">
                                  {emp?.joining_date || "-"}
                                </div>
                              </div>
                              <div className="col-6">
                                <label className="text-muted small d-block">
                                  Salary Type
                                </label>
                                <div className="fw-semibold">
                                  {emp?.salary_type || "-"}
                                </div>
                              </div>
                              <div className="col-6">
                                <label className="text-muted small d-block">
                                  Working Schedule
                                </label>
                                <div className="fw-semibold">
                                  {emp?.working_schedule?.name || "-"}
                                </div>
                              </div>
                              <div className="col-6">
                                <label className="text-muted small d-block">
                                  Hours / Day
                                </label>
                                <div className="fw-semibold">
                                  {emp?.total_hours_per_day || "-"}
                                </div>
                              </div>
                              <div className="col-12">
                                <label className="text-muted small d-block mb-1">
                                  Working Days
                                </label>
                                <div className="d-flex flex-wrap gap-1">
                                  {(() => {
                                    try {
                                      const days = JSON.parse(
                                        emp?.working_days || "[]",
                                      );
                                      return days.map((d) => (
                                        <span
                                          key={d}
                                          className="badge bg-label-secondary"
                                        >
                                          {d}
                                        </span>
                                      ));
                                    } catch {
                                      return "-";
                                    }
                                  })()}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* ---------------- MAIN CONTENT / TABS ---------------- */}
                    <div className="col-xl-8 col-lg-7 col-md-7 order-0 order-md-1">
                      <div className="nav-align-top">
                        <div className="nav nav-tabs nav-fill bg-white rounded shadow-sm mb-4">
                          <div className="nav-item">
                            <button
                              type="button"
                              className={`nav-link ${Tab === "Salary_Details" ? "active" : ""
                                }`}
                              onClick={() => setTab("Salary_Details")}
                            >
                              <i className="ri-bank-card-line me-2"></i>
                              Salary Details
                            </button>
                          </div>

                          <div className="nav-item">
                            <button
                              type="button"
                              className={`nav-link ${Tab === "Salary" ? "active" : ""
                                }`}
                              onClick={() => setTab("Salary")}
                            >
                              <i className="ri-bar-chart-line me-2"></i>
                              Salary Report
                            </button>
                          </div>

                          <div className="nav-item">
                            <button
                              type="button"
                              className={`nav-link ${Tab === "Attendance" ? "active" : ""
                                }`}
                              onClick={() => setTab("Attendance")}
                            >
                              <i className="ri-calendar-check-line me-2"></i>
                              Attendance
                            </button>
                          </div>
                          <div className="nav-item">
                            <button
                              type="button"
                              className={`nav-link ${Tab === "WorkReport" ? "active" : ""
                                }`}
                              onClick={() => setTab("WorkReport")}
                            >
                              <i className="ri-file-list-3-line me-2"></i>
                              Work Report
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-white">
                          <h5 className="mb-0">
                            {Tab === "Salary_Details"
                              ? "Salary Details"
                              : Tab === "Salary"
                                ? "Salary Report"
                                : Tab === "Attendance"
                                  ? "Attendance Report"
                                  : "Work Report History"}
                          </h5>
                        </div>

                        <div className="card-body">
                          {Tab === "Salary_Details" &&
                            hasAccess("/staff/salary/details") && (
                              <SaleryDetails data={Teachers} />
                            )}

                          {Tab === "Salary" &&
                            hasAccess("/staff/salary/report") && (
                              <SaleryInfoTab data={Teachers} />
                            )}

                          {Tab === "Attendance" &&
                            hasAccess("/staff/attendance/report") && (
                              <AttandanceTab data={Teachers} />
                            )}

                          {Tab === "WorkReport" &&
                            hasAccess("/staff/work/report") && (
                              <WorkReportTab data={Teachers} />
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </div>
      <div className="layout-overlay layout-menu-toggle"></div>
      <div className="drag-target"></div>
    </div>
  );
};
export default Teacherview2;
